import React, { Component } from "react";

import { Access } from "common";
import { Page, Breadcrumbs, Navigation } from "components";

import Inhabitant from "assets/images/extraction-inhabitant.svg";

class Main extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Extração", to: "" },
    ],
    navigation: [
      {
        name: "Extração - Dados CPF",
        to: "/extraction/inhabitant",
        icon: Inhabitant,
        hidden: !Access.hasPermissions("manage-extraction"),
      },
      {
        name: "Extração - Vouchers Abandonados",
        to: "/extraction/vouchers",
        icon: null,
        hidden: !Access.hasPermissions("manage-abandoned-vouchers"),
      },
    ],
  };

  render() {
    const { breadcrumbs, navigation } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Navigation items={navigation} />
      </Page>
    );
  }
}

export default Main;
